import classNames from 'classnames';
import { forwardRef, Ref } from 'react';

import testIds from '../testIds';

import useStyles from './styles';

interface IProps {
  onClick: () => void;
  icon: React.ElementType;
  isActive: boolean;
}

const UndoRedoButton = ({
  onClick, icon: Icon, isActive,
}: IProps, ref: Ref<HTMLButtonElement>) => {
  const classes = useStyles();

  const handleClick = () => {
    if (isActive) {
      onClick();
    }
  };

  return (
    <button
      data-testid={testIds.undoRedoButton}
      className={classNames(classes.root, 'we-undoRedo', { [classes.passive]: !isActive, [classes.interactive]: isActive })}
      onClick={handleClick}
      ref={ref}
    >
      <Icon className={classes.icon} />
    </button>
  );
};

export default forwardRef(UndoRedoButton);
